import React from "react";
import PropTypes from 'prop-types';
import {I18n} from "react-redux-i18n";
import Checkbox from "./Checkbox";
import _ from "../../../utils/ObjectUtils";

const CheckboxGroup = ({
    values,
    handleCheckboxClicked,
    handleSelectAllClicked,
    hasSelectAll,
    allSelected,
    title
}) => {
    return (
        <div>
            <div className={"checkboxGroup-title " + (_.isNilOrEmpty(title) ? "hidden" : "") } > { I18n.t("forms.checkbox." + title) } </div>
            <div>
                {Object.keys(values).map( (checkboxLabel, idx) => {
                    const checkboxSate = values[checkboxLabel];
                    return (
                        <span key={idx} className="mr-3">
                            {I18n.t("forms.checkbox." + checkboxLabel)}
                            <Checkbox
                                className="checkbox"
                                checked={checkboxSate}
                                onChange={() => handleCheckboxClicked(checkboxLabel, !checkboxSate)}
                            />
                        </span>
                    )
                })}
            {
                hasSelectAll &&
                <span>
                        { I18n.t("forms.checkbox.selectAll") }
                    <Checkbox
                        className="checkbox"
                        checked={allSelected}
                        onChange={() => handleSelectAllClicked()}
                    />
                    </span>
            }
            </div>
        </div>
    );
};

CheckboxGroup.propTypes = {
    values: PropTypes.object,
    hasSelectAll: PropTypes.bool,
    allSelected: PropTypes.bool,
    handleCheckboxClicked: PropTypes.func,
    handleSelectAllClicked: PropTypes.func,
    title: PropTypes.string
};

export default CheckboxGroup;